<app-breadcrumb [master]="'Struktura sieci'" [parentName]="'Umowy'" [name]="'Zgłoszenia samofakturowanie'"></app-breadcrumb>
<div class="self-billing-form-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="self-billing-form-list-filters" >
    <mat-form-field class="self-billing-form-list-filter">
      <mat-label>ID</mat-label>
      <input matInput placeholder="12345" name="id" [(ngModel)]="initialFilters.id">
    </mat-form-field>

    <app-dict
      [multiple]="false" label="Firma"
      class="self-billing-form-list-filter"
      dictType="company"
      [(ngModel)]="initialFilters.company" name="company"
    ></app-dict>

    <app-dict-regionals
      [noneEntry]="true" [multiple]="true"
      [label]="'Regionalny '"
      class="self-billing-form-list-filter"
      [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
    ></app-dict-regionals>

    <mat-form-field class="self-billing-form-list-filter">
      <mat-label>Partner NIP</mat-label>
      <input matInput placeholder="12345" name="contains$nip" [(ngModel)]="initialFilters.contains$nip">
    </mat-form-field>

    <mat-form-field class="self-billing-form-list-filter">
      <mat-label>Pełna nazwa</mat-label>
      <input matInput placeholder="Pełna nazwa" name="partnerFullName" [(ngModel)]="initialFilters.partnerFullName">
    </mat-form-field>

    <mat-form-field  appearance="standard" class="self-billing-form-list-filter">
      <mat-label>Dodana umowa</mat-label>
      <mat-select [(ngModel)]="initialFilters.contractAdd" name="contractAdd">
        <mat-option [value]="null">Wszyscy</mat-option>
        <mat-option [value]="1">Tak</mat-option>
        <mat-option [value]="0">Nie</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="self-billing-form-list-filter-long">
      <mat-label>Partner Nazwa Skrócona  </mat-label>

      <input matInput placeholder="Nazwa skrócona" name="partnerShortName" [(ngModel)]="initialFilters.partnerShortName">
    </mat-form-field>
  </form>

  <div >

    <div class="self-billing-form-list-buttons">
      <button *ngIf="(userPermissions | async).contract.delete" (click)="downloadReport()" [disabled]="!(userPermissions | async).contract.delete "
               mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>

      <button (click)="filter()" mat-raised-button color="primary">
        <mat-icon>search</mat-icon> <span> Szukaj  </span>
      </button>


      <button (click)="resetFilters()" mat-raised-button color="warn">
        <mat-icon>delete</mat-icon> <span> Resetuj filtry</span>
      </button>
    </div>

  </div>

  <table mat-table [dataSource]="selfBillingForm" multiTemplateDataRows>
    <!-- Position Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef> ID rekordu</th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        {{element.id}}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>  Nazwa Partnera</th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)" >
        <a class="default-link" [routerLink]="['/partnerzy/szczegoly/', element.partner.uuid]"> {{element.partner.fullName}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef> Firma</th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        {{element.company.name}}
      </td>
    </ng-container>

    <ng-container matColumnDef="regional">
      <th mat-header-cell *matHeaderCellDef> Regionalny Partnera</th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        {{element.partner.assetsRegional?.firstName}} {{element.partner.assetsRegional?.lastName}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createAt">
      <th mat-header-cell *matHeaderCellDef> Data dodania zgłoszenia</th>
      <td mat-cell *matCellDef="let element" (click)="expandElement(element)">
        {{element.createdAt | date:'y-MM-dd'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>  </th>
      <td mat-cell *matCellDef="let element">

        <button *ngIf="!element.closeAt" [disabled]="!(userPermissions | async).contract.delete" mat-stroked-button color="primary"  (click)="addContract(element)"><mat-icon>add</mat-icon> Dodaj umowę</button>
        <button *ngIf="element.closeAt" mat-icon-button ><mat-icon class="positive-icon">check_circle</mat-icon></button>
      </td>
    </ng-container>

    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="expanded-row-td">
        <div class="expanded-data" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
          <div fxFlex="100" *ngIf="element == expandedElement">
            <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
              <div fxFlex = "100" fxFlex.lt-md="100" fxLayoutGap="15px">
                <mat-card >
                  <div fxLayout="row" fxLayoutGap="15px">
                    <div fxFlex="30">
                      <app-detail header="Numer telefonu" [value]="element.phone"></app-detail>
                    </div>

                    <div fxFlex="36">
                      <app-detail header="Adres email" [value]="element.email"></app-detail>
                    </div>

                    <div fxFlex="33">
                      <app-detail header="Numer rachunku" [value]="element.accountNumber"></app-detail>
                    </div>
                  </div>
                </mat-card>
              </div>
            </div>          </div>

        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button *ngIf="!element.closeAt"  (click)="delete(element.id)" mat-icon-button color="warn"><mat-icon>delete</mat-icon> </button>

      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      class="table-row"
      mat-row *matRowDef="let element; let row; columns: displayedColumns;"
      [class.expanded-row]="expandedElement === element"
      [class.not-expanded-row]="expandedElement && expandedElement !== element"
      [ngClass]="{'overvoltage': element.overvoltage}"
    ></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" [ngClass]="{'overvoltageDisable': row.overvoltage}" class="expanded-data-row"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
</div>
